import React, { useEffect, useState } from "react";

import { auth } from "../../../Firebase/firebase";
import { connect } from "react-redux";
import * as actionCreators from "../../../Store/actions/index";
import { priceFormater } from "../../Utility/Utility";
import camera from "../../../assets/svg/camera.svg";
import heart from "../../../assets/svg/balckHeart.svg";
import redHeart from "../../../assets/svg/redHeart.svg";
import Yellowstar from "../../../assets/svg/Yellowstar.svg";
import EmptyYellowstar from "../../../assets/svg/EmptyYellowstar.svg";
// import Like from "../../../assets/svg/like.svg";
import carImg from "../../../assets/Img/carIMg.png";
import unKnownDealer from "../../../assets/Img/unKnownDealer.jpg";
import doubleQoute from "../../../assets/Img/doubleQoute.png";
import classes from "./ListView.module.css";
import Spinner from "../../../Component/UI/spinner/Spinner";
import HeartSpin from "../../UI/spinner/HeartSpin";

const ListView = (props) => {
    const [currentItemWishing, setCurrentItemWishing] = useState(null);
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const checkItemIsWishLIsted = (itemId) => {
        let isWishItem = false;
        let wishArray = localStorage.getItem('myWish');
        if (props.user && props.wishIdsArray && wishArray) {
            wishArray = wishArray.split(',');
            isWishItem = wishArray.some((id) => {
                return +id === itemId
            })
        }
        return isWishItem
    }
    const addItmeToWishList = (itemId, userIsAuth) => {
        if (!props.user) {
            props.showAuthHandler('signIn')
        }
        else {
            const itemIsWishListed = checkItemIsWishLIsted(itemId);
            if (!itemIsWishListed) {
                let token = localStorage.getItem('idToken')
                if (!token) {
                    const fireUser = auth.currentUser
                    if (fireUser) {
                        fireUser.getIdToken().then(newToken => {
                            token = newToken
                            props.AddItemToWishList(itemId, token)
                        })
                    }
                    else {
                        console.log(fireUser)
                    }
                }
                else {
                    props.AddItemToWishList(itemId, token)
                }
            }
            else {
                console.log(itemId, userIsAuth, 'in my WishList')
            }
        }
    };
    let item = <Spinner />;
    if (props.listVehicleItems.data) {
        let dataArray = props.listVehicleItems.data;
        // const sorteData = sortter(props.sortT, dataArray)
        //#####################################################################################
        item = dataArray.map(listItem => {
            let mediaImg = carImg;
            let isWishItem = false;
            let wishArray = localStorage.getItem('myWish');
            if (listItem.media.length !== 0) {
                try {
                    mediaImg = listItem.media.filter(img => {
                        if (img.name === "video") {
                            return { url: "https://storage.googleapis.com/pcari-71145.appspot.com/media/png/HwN1Eapr6U.png" }
                        }
                        return img.name === 'front';
                    })[0].url;
                } catch (error) {
                    mediaImg = listItem.media[0].url
                }
            }
            if (props.user && props.wishIdsArray && wishArray) {
                wishArray = wishArray.split(',');
                isWishItem = wishArray.some((id) => {
                    return +id === listItem.id
                })
            }
            const tailer = mediaImg.slice(-4);
            return (
                <div className={classes.ListViewItem} key={listItem.id} >
                    <div className={classes.itemImage} onClick={() => props.routProp.history.push(`/Detail?vehicle=${listItem.id}&type=${listItem.vehicle_type}`)}>
                        <div className={classes.positioningCamera}>
                            <img src={camera} alt='num' /><small>{listItem.media.length} +</small>
                        </div>
                        {tailer === '.mp4' ?
                            <video width='100%' height='200px'>
                                <source src={mediaImg} type='video/mp4' />
                            </video>
                            :
                            <img src={mediaImg} alt='car images' />
                        }
                        {props.addingItem && currentItemWishing === listItem.id ?
                            <div className={classes.AddingWish}>
                                <HeartSpin />
                            </div>
                            :
                            <div
                                className={classes.positioningHeart}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setCurrentItemWishing(listItem.id)
                                    addItmeToWishList(listItem.id, props.user !== null)
                                }}>
                                <img src={isWishItem ? redHeart : heart} alt='num' />
                            </div>
                        }
                    </div>
                    <div className={classes.ItemInfo}
                        onClick={(event) => {
                            props.routProp.history.push(`/Detail?vehicle=${listItem.id}&type=${listItem.vehicle_type}`)
                        }}>
                        <h1>{listItem.title}</h1>
                        <div className={classes.Info}>
                            <div className={classes.SellerPitch}>
                                <img src={doubleQoute} alt='' />
                                <p>Seller's Picthc </p>
                                {listItem.seller_pitch}
                            </div>
                            <div className={classes.ItemDetails}>
                                <div className={classes.DetailsRow}>
                                    <p className={classes.Btn}>{listItem.condition}</p>
                                    {listItem.is_featured ? <p className={classes.Btn}>Featured</p> : null}
                                    <p className={classes.Btn}>{listItem.body_type}</p>
                                </div>
                                <div className={`${classes.DetailsRow} ${classes.Light}`}>
                                    <p>Driven :</p>
                                    <p>Origin :</p>
                                    <p>Transmission :</p>
                                </div>
                                <div className={`${classes.DetailsRow} ${classes.Dark}`}>
                                    <p>{listItem.driven_wheel}</p>
                                    <p>{listItem.origin}</p>
                                    <p>{listItem.transmission}</p>
                                </div>
                                <div className={`${classes.DetailsRow} ${classes.Light}`}>
                                    <p>Fuel :</p>
                                    <p>Mileage :</p>
                                    <p>Location :</p>
                                </div>
                                <div className={`${classes.DetailsRow} ${classes.Dark}`}>
                                    <p>{listItem.fuel_type}</p>
                                    <p>{listItem.mileage}</p>
                                    <p>{listItem.state ? listItem.state.name : null}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.Dealer}>
                        <div className={classes.DealerInfo}>
                            <img src={unKnownDealer} alt='Dealer' width='50px' />
                            <div className={classes.DealerDetila}>
                                <h2>{listItem.seller.name}</h2>
                                <p> {listItem.seller.company_name ? 'Company' : 'Private'} {/*<img src={Like} width='14%' alt='' />*/}</p>
                                <div>
                                    <img src={Yellowstar} alt='' />
                                    <img src={Yellowstar} alt='' />
                                    <img src={Yellowstar} alt='' />
                                    <img src={Yellowstar} alt='' />
                                    <img src={EmptyYellowstar} alt='' />
                                </div>
                            </div>
                        </div>
                        <button className={classes.BtnBig}>
                            RM {priceFormater(listItem.price)}
                        </button>
                        <button
                            className={classes.BtnColored}
                            onClick={() => {
                                props.onToggelContactNow(listItem.seller.id, listItem.seller.name, listItem.seller.phone)
                            }}>
                            Contact Now
                        </button>
                    </div>
                </div>
            );
        })
    }

    return (

        <div className={classes.ListView}>
            {item}
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onToggelContactNow: (id, name, phone) => { dispatch(actionCreators.toggelContactShow(id, name, phone)) }
    }
}

export default connect(null, mapDispatchToProps)(ListView);